import Styled from "styled-components"

export default Styled.div`
background-color: #e2f3ff;
padding: 20px 15px;
border-radius: 5px;
border: 1px solid rgba(0,0,0,0.05);
margin-bottom: var(--m-two-lines);
`
